"use strict";
import Cookies from "js-cookie";
export default class Session {
  static set(name, value) {
    const _data = JSON.stringify(value);
    Cookies.set(name, _data);
  }
  static get(name) {
    const _data = Cookies.get(name);
    if (!_data) {
      return null;
    }
    return JSON.parse(_data);
  }
}
export class Storage {
  // static install(Vue:any){
  //     let session = localStorage.getItem('account_session')
  //     if (session){
  //         Vue.prototype.$session = JSON.parse(session) as AccountSessionModel;
  //     }
  //
  // }
  static set(name, value) {
    const _data = JSON.stringify(value);
    localStorage.setItem(name, _data);
  }
  static get(name) {
    const _data = localStorage.getItem(name);
    if (!_data) {
      return null;
    }
    return JSON.parse(_data);
  }
}
export class SessionStore {
  static set(name, value) {
    return sessionStorage.setItem(name, JSON.stringify(value));
  }
  static get(name) {
    let data = sessionStorage.getItem(name);
    if (data !== null) {
      data = JSON.parse(data);
    }
    return data;
  }
}
